module.exports = __webpack_public_path__ + "img/06.dda27c50.jpg";